import { VERSION } from '../../../version';

const ID = 'footer';

const Footer = () => {
    return (
        <div
            id={ID}
            className='fixed-bottom d-flex justify-content-between align-items-center min-height-20 w-100 flex-row'
            onClick={() => window.location.reload()}>
            <span>{VERSION}</span>
        </div>
    );
};

export default Footer;
